// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2023 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-notebook-markdown-size: 17px;
  --theia-notebook-cell-editor-margin-right: 10px;
}

.theia-notebook-cell-list {
  position: absolute;
  top: 0;
  width: 100%;
  overflow-y: auto;
  list-style: none;
  padding-left: 0px;
  background-color: var(--theia-notebook-editorBackground);
  z-index: 0;
  pointer-events: none;
}


.theia-notebook-cell-output-webview {
  padding: 5px 0px;
  margin: 0px 15px 0px 50px;
  width: calc(100% - 60px);
  position: absolute;
  z-index: 0;
}

.theia-notebook-cell {
  display: flex;
  margin: 10px 0px;
}

.theia-notebook-cell:focus {
  outline: none;
}

.theia-notebook-cell.draggable {
  cursor: grab;
}

.theia-notebook-cell:hover .theia-notebook-cell-marker {
  visibility: visible;
}

.theia-notebook-cell-marker {
  background-color: var(--theia-notebook-inactiveFocusedCellBorder);
  width: 3px;
  margin: 0px 8px 0px 4px;
  border-radius: 4px;
  visibility: hidden;
}

.theia-notebook-cell-marker-selected {
  visibility: visible;
  background-color: var(--theia-notebook-focusedCellBorder);
}

.theia-notebook-cell-marker:hover {
  width: 5px;
  margin: 0px 6px 0px 4px;
}

.theia-notebook-cell-content {
  flex: 1;
  width: calc(100% - 15px);
}

/* Rendered Markdown Content */

.theia-notebook-markdown-content {
  pointer-events: all;
  padding: 8px 16px 8px 0px;
  font-size: var(--theia-notebook-markdown-size);
}

.theia-notebook-markdown-content>* {
  font-weight: 400;
}

.theia-notebook-markdown-content>*:first-child {
  margin-top: 0;
  padding-top: 0;
}

.theia-notebook-markdown-content>*:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.theia-notebook-markdown-sidebar {
  width: 35px;
}

/* Markdown cell edit mode */
.theia-notebook-cell-content:has(.theia-notebook-markdown-editor-container>.theia-notebook-cell-editor) {
  pointer-events: all;
  margin-right: var(--theia-notebook-cell-editor-margin-right);
  outline: 1px solid var(--theia-notebook-cellBorderColor);
}

/* Markdown cell edit mode focused */
.theia-notebook-cell.focused .theia-notebook-cell-content:has(.theia-notebook-markdown-editor-container>.theia-notebook-cell-editor) {
  outline-color: var(--theia-notebook-focusedEditorBorder);
}

.theia-notebook-empty-markdown {
  opacity: 0.6;
}

.theia-notebook-cell-editor {
  padding: 10px 10px 0 10px;
}

.theia-notebook-cell-editor-container {
  pointer-events: all;
  width: calc(100% - 46px);
  flex: 1;
  outline: 1px solid var(--theia-notebook-cellBorderColor);
  margin: 0px 16px 0px 10px;
}

/* Only mark an editor cell focused if the editor has focus */
.theia-notebook-cell-editor-container:has(.monaco-editor.focused) {
  outline-color: var(--theia-notebook-focusedEditorBorder);
}

.notebook-cell-status {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  height: 16px;
}

.notebook-cell-status-left {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.notebook-cell-language-label {
  padding: 0 5px;
}

.notebook-cell-language-label:hover {
  cursor: pointer;
  background-color: var(--theia-toolbar-hoverBackground);
}

.notebook-cell-status-item {
  margin: 0 3px;
  padding: 0 3px;
  display: flex;
  align-items: center;
}

.theia-notebook-cell-toolbar {
  pointer-events: all;
  border: 1px solid var(--theia-notebook-cellToolbarSeparator);
  display: flex;
  position: absolute;
  margin: -20px 0 0 66px;
  padding: 2px;
  background-color: var(--theia-editor-background);
}

.theia-notebook-cell-sidebar-toolbar {
  display: flex;
  flex-direction: column;
  padding: 2px;
  flex-grow: 1;
}

.theia-notebook-cell-sidebar {
  pointer-events: all;
  display: flex;
}

.theia-notebook-cell-sidebar-actions {
  display: flex;
  flex-direction: column;
}

.theia-notebook-code-cell-execution-order {
  display: block;
  font-family: var(--monaco-monospace-font);
  font-size: 10px;
  opacity: 0.7;
  text-align: center;
  white-space: pre;
  padding: 5px 0;
}

.theia-notebook-cell-toolbar-item {
  height: 18px;
  width: 18px;
}

.theia-notebook-cell-toolbar-item:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-cell-toolbar-item:active {
  background-color: var(--theia-toolbar-active);
}

.theia-notebook-cell-divider {
  pointer-events: all;
  height: 25px;
  width: 100%;
}

.theia-notebook-cell-with-sidebar {
  display: flex;
  flex-direction: row;
}

.theia-notebook-main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.theia-notebook-main-container:focus {
  outline: none;
}

.theia-notebook-main-container .theia-notebook-main-loading-indicator {
  /* \`progress-animation\` is defined in \`packages/core/src/browser/style/progress-bar.css\` */
  animation: progress-animation 1.8s 0s infinite cubic-bezier(0.645, 0.045, 0.355, 1);
  background-color: var(--theia-progressBar-background);
  height: 2px;
}

.theia-notebook-viewport {
  display: flex;
  overflow: hidden;
  height: 100%;
}

.theia-notebook-scroll-container {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.theia-notebook-main-toolbar {
  background: var(--theia-editor-background);
  display: flex;
  flex-direction: row;
  z-index: 1;
  /*needed to be on rendered on top of monaco editors*/
}

.theia-notebook-main-toolbar-item {
  height: 22px;
  display: flex;
  align-items: center;
  margin: 0 4px;
  padding: 2px;
  text-align: center;
  color: var(--theia-foreground) !important;
  cursor: pointer;
}

.theia-notebook-main-toolbar-item.theia-mod-disabled:hover {
  background-color: transparent;
  cursor: default;
}

.theia-notebook-main-toolbar-item-text {
  padding: 0 4px;
  white-space: nowrap;
}

.theia-notebook-toolbar-separator {
  width: 1px;
  background-color: var(--theia-notebook-cellToolbarSeparator);
  margin: 0 4px;
}

.theia-notebook-add-cell-buttons {
  justify-content: center;
  display: flex;
}

.theia-notebook-add-cell-button {
  border: 1px solid var(--theia-notebook-cellToolbarSeparator);
  background-color: var(--theia-editor-background);
  color: var(--theia-foreground);
  display: flex;
  height: 24px;
  margin: 0 8px;
  padding: 2px 4px;
}

.theia-notebook-add-cell-button:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-add-cell-button:active {
  background-color: var(--theia-toolbar-active);
}

.theia-notebook-add-cell-button>* {
  vertical-align: middle;
}

.theia-notebook-add-cell-button-icon::before {
  font: normal normal normal 14px/1 codicon;
}

.theia-notebook-add-cell-button-text {
  margin: 1px 0 0 4px;
}

.theia-notebook-cell-drop-indicator {
  height: 2px;
  background-color: var(--theia-notebook-focusedCellBorder);
  width: 100%;
}

.theia-notebook-collapsed-output-container {
  width: 0;
  overflow: visible;
}

.theia-notebook-collapsed-output {
  text-wrap: nowrap;
  padding: 4px 8px;
  color: var(--theia-foreground);
  margin-left: 30px;
  font-size: 14px;
  line-height: 22px;
  opacity: 0.7;
}

.theia-notebook-drag-ghost-image {
  position: absolute;
  top: -99999px;
  left: -99999px;
  max-height: 500px;
  min-height: 100px;
  background-color: var(--theia-editor-background);
}

/* Notebook Find Widget */

.theia-notebook-overlay {
  position: absolute;
  z-index: 100;
  right: 18px;
}

.theia-notebook-find-widget {
  /* position: absolute;
  z-index: 35;
  height: 33px;
  overflow: hidden; */
  line-height: 19px;
  transition: transform 200ms linear;
  display: flex;
  flex-direction: row;
  padding: 0 4px;
  box-sizing: border-box;
  box-shadow: 0 0 8px 2px var(--theia-widget-shadow);
  background-color: var(--theia-editorWidget-background);
  color: var(--theia-editorWidget-foreground);
  border-left: 1px solid var(--theia-widget-border);
  border-right: 1px solid var(--theia-widget-border);
  border-bottom: 1px solid var(--theia-widget-border);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.theia-notebook-find-widget.hidden {
  display: none;
  transform: translateY(calc(-100% - 10px));
}

.theia-notebook-find-widget.search-mode>*>*:nth-child(2) {
  display: none;
}

.theia-notebook-find-widget-expand {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 0;
  margin-right: 4px;
}

.theia-notebook-find-widget-expand:focus {
  outline: 1px solid var(--theia-focusBorder);
}

.theia-notebook-find-widget-expand:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-find-widget-buttons-first {
  margin-bottom: 4px;
  height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.theia-notebook-find-widget-buttons-first>div,
.theia-notebook-find-widget-buttons-second>div {
  margin-right: 4px;
}

.theia-notebook-find-widget-buttons-second {
  height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.theia-notebook-find-widget-inputs {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}

.theia-notebook-find-widget-buttons {
  margin-top: 4px;
  margin-left: 4px;
  display: flex;
  flex-direction: column;
}

.theia-notebook-find-widget-matches-count {
  width: 72px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-notebook-find-widget-input-wrapper {
  display: flex;
  align-items: center;
  background: var(--theia-input-background);
  border-style: solid;
  border-width: var(--theia-border-width);
  border-color: var(--theia-input-background);
  border-radius: 2px;
  margin-bottom: 4px;
}

.theia-notebook-find-widget-input-wrapper:focus-within {
  border-color: var(--theia-focusBorder);
}

.theia-notebook-find-widget-input-wrapper .option.enabled {
  color: var(--theia-inputOption-activeForeground);
  outline: 1px solid var(--theia-inputOption-activeBorder);
  background-color: var(--theia-inputOption-activeBackground);
}

.theia-notebook-find-widget-input-wrapper .option {
  margin: 2px;
}

.theia-notebook-find-widget-input-wrapper .theia-notebook-find-widget-input:focus {
  border: none;
  outline: none;
}

.theia-notebook-find-widget-input-wrapper .theia-notebook-find-widget-input {
  background: none;
  border: none;
}

.theia-notebook-find-widget-replace {
  margin-bottom: 4px;
}

.theia-notebook-find-widget-buttons .disabled {
  opacity: 0.5;
}

mark.theia-find-match {
  color: var(--theia-editor-findMatchHighlightForeground);
  background-color: var(--theia-editor-findMatchHighlightBackground);
}

mark.theia-find-match.theia-find-match-selected {
  color: var(--theia-editor-findMatchForeground);
  background-color: var(--theia-editor-findMatchBackground);
}

.cell-status-bar-item {
  align-items: center;
  display: flex;
  height: 16px;
  margin: 0 3px;
  overflow: hidden;
  padding: 0 3px;
  text-overflow: clip;
  white-space: pre;
}

.cell-status-item-has-command {
  cursor: pointer;
}

.cell-status-item-has-command:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/notebook/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wDAAwD;EACxD,UAAU;EACV,oBAAoB;AACtB;;;AAGA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA,8BAA8B;;AAE9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,wDAAwD;AAC1D;;AAEA,oCAAoC;AACpC;EACE,wDAAwD;AAC1D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,OAAO;EACP,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0FAA0F;EAC1F,mFAAmF;EACnF,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,gDAAgD;EAChD,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;;;qBAGmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,kDAAkD;EAClD,sDAAsD;EACtD,2CAA2C;EAC3C,iDAAiD;EACjD,kDAAkD;EAClD,mDAAmD;EACnD,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,2DAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,kEAAkE;AACpE;;AAEA;EACE,8CAA8C;EAC9C,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sDAAsD;AACxD","sourcesContent":["/********************************************************************************\n * Copyright (C) 2023 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-notebook-markdown-size: 17px;\n  --theia-notebook-cell-editor-margin-right: 10px;\n}\n\n.theia-notebook-cell-list {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  overflow-y: auto;\n  list-style: none;\n  padding-left: 0px;\n  background-color: var(--theia-notebook-editorBackground);\n  z-index: 0;\n  pointer-events: none;\n}\n\n\n.theia-notebook-cell-output-webview {\n  padding: 5px 0px;\n  margin: 0px 15px 0px 50px;\n  width: calc(100% - 60px);\n  position: absolute;\n  z-index: 0;\n}\n\n.theia-notebook-cell {\n  display: flex;\n  margin: 10px 0px;\n}\n\n.theia-notebook-cell:focus {\n  outline: none;\n}\n\n.theia-notebook-cell.draggable {\n  cursor: grab;\n}\n\n.theia-notebook-cell:hover .theia-notebook-cell-marker {\n  visibility: visible;\n}\n\n.theia-notebook-cell-marker {\n  background-color: var(--theia-notebook-inactiveFocusedCellBorder);\n  width: 3px;\n  margin: 0px 8px 0px 4px;\n  border-radius: 4px;\n  visibility: hidden;\n}\n\n.theia-notebook-cell-marker-selected {\n  visibility: visible;\n  background-color: var(--theia-notebook-focusedCellBorder);\n}\n\n.theia-notebook-cell-marker:hover {\n  width: 5px;\n  margin: 0px 6px 0px 4px;\n}\n\n.theia-notebook-cell-content {\n  flex: 1;\n  width: calc(100% - 15px);\n}\n\n/* Rendered Markdown Content */\n\n.theia-notebook-markdown-content {\n  pointer-events: all;\n  padding: 8px 16px 8px 0px;\n  font-size: var(--theia-notebook-markdown-size);\n}\n\n.theia-notebook-markdown-content>* {\n  font-weight: 400;\n}\n\n.theia-notebook-markdown-content>*:first-child {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.theia-notebook-markdown-content>*:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.theia-notebook-markdown-sidebar {\n  width: 35px;\n}\n\n/* Markdown cell edit mode */\n.theia-notebook-cell-content:has(.theia-notebook-markdown-editor-container>.theia-notebook-cell-editor) {\n  pointer-events: all;\n  margin-right: var(--theia-notebook-cell-editor-margin-right);\n  outline: 1px solid var(--theia-notebook-cellBorderColor);\n}\n\n/* Markdown cell edit mode focused */\n.theia-notebook-cell.focused .theia-notebook-cell-content:has(.theia-notebook-markdown-editor-container>.theia-notebook-cell-editor) {\n  outline-color: var(--theia-notebook-focusedEditorBorder);\n}\n\n.theia-notebook-empty-markdown {\n  opacity: 0.6;\n}\n\n.theia-notebook-cell-editor {\n  padding: 10px 10px 0 10px;\n}\n\n.theia-notebook-cell-editor-container {\n  pointer-events: all;\n  width: calc(100% - 46px);\n  flex: 1;\n  outline: 1px solid var(--theia-notebook-cellBorderColor);\n  margin: 0px 16px 0px 10px;\n}\n\n/* Only mark an editor cell focused if the editor has focus */\n.theia-notebook-cell-editor-container:has(.monaco-editor.focused) {\n  outline-color: var(--theia-notebook-focusedEditorBorder);\n}\n\n.notebook-cell-status {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  height: 16px;\n}\n\n.notebook-cell-status-left {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n\n.notebook-cell-language-label {\n  padding: 0 5px;\n}\n\n.notebook-cell-language-label:hover {\n  cursor: pointer;\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.notebook-cell-status-item {\n  margin: 0 3px;\n  padding: 0 3px;\n  display: flex;\n  align-items: center;\n}\n\n.theia-notebook-cell-toolbar {\n  pointer-events: all;\n  border: 1px solid var(--theia-notebook-cellToolbarSeparator);\n  display: flex;\n  position: absolute;\n  margin: -20px 0 0 66px;\n  padding: 2px;\n  background-color: var(--theia-editor-background);\n}\n\n.theia-notebook-cell-sidebar-toolbar {\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  flex-grow: 1;\n}\n\n.theia-notebook-cell-sidebar {\n  pointer-events: all;\n  display: flex;\n}\n\n.theia-notebook-cell-sidebar-actions {\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-notebook-code-cell-execution-order {\n  display: block;\n  font-family: var(--monaco-monospace-font);\n  font-size: 10px;\n  opacity: 0.7;\n  text-align: center;\n  white-space: pre;\n  padding: 5px 0;\n}\n\n.theia-notebook-cell-toolbar-item {\n  height: 18px;\n  width: 18px;\n}\n\n.theia-notebook-cell-toolbar-item:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-cell-toolbar-item:active {\n  background-color: var(--theia-toolbar-active);\n}\n\n.theia-notebook-cell-divider {\n  pointer-events: all;\n  height: 25px;\n  width: 100%;\n}\n\n.theia-notebook-cell-with-sidebar {\n  display: flex;\n  flex-direction: row;\n}\n\n.theia-notebook-main-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.theia-notebook-main-container:focus {\n  outline: none;\n}\n\n.theia-notebook-main-container .theia-notebook-main-loading-indicator {\n  /* `progress-animation` is defined in `packages/core/src/browser/style/progress-bar.css` */\n  animation: progress-animation 1.8s 0s infinite cubic-bezier(0.645, 0.045, 0.355, 1);\n  background-color: var(--theia-progressBar-background);\n  height: 2px;\n}\n\n.theia-notebook-viewport {\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n}\n\n.theia-notebook-scroll-container {\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n}\n\n.theia-notebook-main-toolbar {\n  background: var(--theia-editor-background);\n  display: flex;\n  flex-direction: row;\n  z-index: 1;\n  /*needed to be on rendered on top of monaco editors*/\n}\n\n.theia-notebook-main-toolbar-item {\n  height: 22px;\n  display: flex;\n  align-items: center;\n  margin: 0 4px;\n  padding: 2px;\n  text-align: center;\n  color: var(--theia-foreground) !important;\n  cursor: pointer;\n}\n\n.theia-notebook-main-toolbar-item.theia-mod-disabled:hover {\n  background-color: transparent;\n  cursor: default;\n}\n\n.theia-notebook-main-toolbar-item-text {\n  padding: 0 4px;\n  white-space: nowrap;\n}\n\n.theia-notebook-toolbar-separator {\n  width: 1px;\n  background-color: var(--theia-notebook-cellToolbarSeparator);\n  margin: 0 4px;\n}\n\n.theia-notebook-add-cell-buttons {\n  justify-content: center;\n  display: flex;\n}\n\n.theia-notebook-add-cell-button {\n  border: 1px solid var(--theia-notebook-cellToolbarSeparator);\n  background-color: var(--theia-editor-background);\n  color: var(--theia-foreground);\n  display: flex;\n  height: 24px;\n  margin: 0 8px;\n  padding: 2px 4px;\n}\n\n.theia-notebook-add-cell-button:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-add-cell-button:active {\n  background-color: var(--theia-toolbar-active);\n}\n\n.theia-notebook-add-cell-button>* {\n  vertical-align: middle;\n}\n\n.theia-notebook-add-cell-button-icon::before {\n  font: normal normal normal 14px/1 codicon;\n}\n\n.theia-notebook-add-cell-button-text {\n  margin: 1px 0 0 4px;\n}\n\n.theia-notebook-cell-drop-indicator {\n  height: 2px;\n  background-color: var(--theia-notebook-focusedCellBorder);\n  width: 100%;\n}\n\n.theia-notebook-collapsed-output-container {\n  width: 0;\n  overflow: visible;\n}\n\n.theia-notebook-collapsed-output {\n  text-wrap: nowrap;\n  padding: 4px 8px;\n  color: var(--theia-foreground);\n  margin-left: 30px;\n  font-size: 14px;\n  line-height: 22px;\n  opacity: 0.7;\n}\n\n.theia-notebook-drag-ghost-image {\n  position: absolute;\n  top: -99999px;\n  left: -99999px;\n  max-height: 500px;\n  min-height: 100px;\n  background-color: var(--theia-editor-background);\n}\n\n/* Notebook Find Widget */\n\n.theia-notebook-overlay {\n  position: absolute;\n  z-index: 100;\n  right: 18px;\n}\n\n.theia-notebook-find-widget {\n  /* position: absolute;\n  z-index: 35;\n  height: 33px;\n  overflow: hidden; */\n  line-height: 19px;\n  transition: transform 200ms linear;\n  display: flex;\n  flex-direction: row;\n  padding: 0 4px;\n  box-sizing: border-box;\n  box-shadow: 0 0 8px 2px var(--theia-widget-shadow);\n  background-color: var(--theia-editorWidget-background);\n  color: var(--theia-editorWidget-foreground);\n  border-left: 1px solid var(--theia-widget-border);\n  border-right: 1px solid var(--theia-widget-border);\n  border-bottom: 1px solid var(--theia-widget-border);\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.theia-notebook-find-widget.hidden {\n  display: none;\n  transform: translateY(calc(-100% - 10px));\n}\n\n.theia-notebook-find-widget.search-mode>*>*:nth-child(2) {\n  display: none;\n}\n\n.theia-notebook-find-widget-expand {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 0;\n  margin-right: 4px;\n}\n\n.theia-notebook-find-widget-expand:focus {\n  outline: 1px solid var(--theia-focusBorder);\n}\n\n.theia-notebook-find-widget-expand:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-find-widget-buttons-first {\n  margin-bottom: 4px;\n  height: 26px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.theia-notebook-find-widget-buttons-first>div,\n.theia-notebook-find-widget-buttons-second>div {\n  margin-right: 4px;\n}\n\n.theia-notebook-find-widget-buttons-second {\n  height: 26px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.theia-notebook-find-widget-inputs {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-notebook-find-widget-buttons {\n  margin-top: 4px;\n  margin-left: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-notebook-find-widget-matches-count {\n  width: 72px;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-notebook-find-widget-input-wrapper {\n  display: flex;\n  align-items: center;\n  background: var(--theia-input-background);\n  border-style: solid;\n  border-width: var(--theia-border-width);\n  border-color: var(--theia-input-background);\n  border-radius: 2px;\n  margin-bottom: 4px;\n}\n\n.theia-notebook-find-widget-input-wrapper:focus-within {\n  border-color: var(--theia-focusBorder);\n}\n\n.theia-notebook-find-widget-input-wrapper .option.enabled {\n  color: var(--theia-inputOption-activeForeground);\n  outline: 1px solid var(--theia-inputOption-activeBorder);\n  background-color: var(--theia-inputOption-activeBackground);\n}\n\n.theia-notebook-find-widget-input-wrapper .option {\n  margin: 2px;\n}\n\n.theia-notebook-find-widget-input-wrapper .theia-notebook-find-widget-input:focus {\n  border: none;\n  outline: none;\n}\n\n.theia-notebook-find-widget-input-wrapper .theia-notebook-find-widget-input {\n  background: none;\n  border: none;\n}\n\n.theia-notebook-find-widget-replace {\n  margin-bottom: 4px;\n}\n\n.theia-notebook-find-widget-buttons .disabled {\n  opacity: 0.5;\n}\n\nmark.theia-find-match {\n  color: var(--theia-editor-findMatchHighlightForeground);\n  background-color: var(--theia-editor-findMatchHighlightBackground);\n}\n\nmark.theia-find-match.theia-find-match-selected {\n  color: var(--theia-editor-findMatchForeground);\n  background-color: var(--theia-editor-findMatchBackground);\n}\n\n.cell-status-bar-item {\n  align-items: center;\n  display: flex;\n  height: 16px;\n  margin: 0 3px;\n  overflow: hidden;\n  padding: 0 3px;\n  text-overflow: clip;\n  white-space: pre;\n}\n\n.cell-status-item-has-command {\n  cursor: pointer;\n}\n\n.cell-status-item-has-command:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
